import styled from 'styled-components';
import { colors } from 'constants/colors';
import { styleSizes } from "constants/styleSizes";

export const BasicModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: ${colors.white};
  border-radius: 8px;
  z-index: 200;
  width: 100%;
  max-width: 90%;
  min-width: 310px;

  .closeButton {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  .cardTitle {
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.checkOutTableTextColor};
  }

  .contentTitle {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin: 32px 32px 16px 32px;
    line-height: 36px;
    @media (max-width: ${styleSizes.miniBreakpoint}) {
      margin: 16px 16px 16px 16px;
  }
  }

  .description {
    width: 100%;
    font-size: 16px;
    text-align: center;
    line-height: 24px;
    margin-bottom: 16px;
  }
  .warning {
      color: ${colors.red};
      font-weight: 400;
    }
`;

export const CancelModalContainer = styled(BasicModalContainer)`

  max-width: 490px;
  @media (max-width: ${styleSizes.miniBreakpoint}) {
    max-width: none;
    width: 90%;
  }
  //min-height: 365px;
  padding: 24px 32px 32px 32px;
  
  .buttonContainer {
    width: 100%;
    display: flex;
    margin: 10px 0 0 0;
    justify-content: flex-end;
    align-items: center;
    column-gap: 24px;
    .link{
      font-size: 16px;
      font-weight: bold;
      color: ${colors.hoverBlue};
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .textareaContainer {
    width: 100%;
  }

  .warning {
      color: ${colors.red};
      font-weight: 400;
    }
`;